import HttpService from './httpService';


class DeliveryChargesService {
  
  private baseUrl = '/delivery-charges';

  async getDeliveryCharges(): Promise<any> {
   return await HttpService.get<any>(this.baseUrl);
  }


  async updateDeliverySettings(settings: any): Promise<void> {
    return HttpService.patch(`${this.baseUrl}`, settings);
  }
}

export const deliveryChargesService = new DeliveryChargesService(); 